import { PhotoCapture } from '../enums';
export const PHOTO_CAPTURE_SHOP_SELECTION_SCREEN_VISITED = `${PhotoCapture.PHOTO_CAPTURE}_SHOP_SELECTION_SCREEN_VISITED`;
/**
 * Action creator to mark the shop selection screen as visited
 * @param isVisited Whether the shop selection screen has been visited
 * @returns Action object
 */
export const photoCaptureShopSelectionScreenVisitedAction = (isVisited) => ({
    type: PHOTO_CAPTURE_SHOP_SELECTION_SCREEN_VISITED,
    payload: isVisited
});
//# sourceMappingURL=photoCaptureShopSelectionScreenVisitedAction.js.map